import { render, staticRenderFns } from "./shopType.vue?vue&type=template&id=966a00b0&scoped=true&"
import script from "./shopType.vue?vue&type=script&lang=js&"
export * from "./shopType.vue?vue&type=script&lang=js&"
import style0 from "./shopType.vue?vue&type=style&index=0&id=966a00b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a00b0",
  null
  
)

export default component.exports